import { render } from "./FaultReasonChart.vue?vue&type=template&id=ede006d4"
import script from "./FaultReasonChart.vue?vue&type=script&lang=js"
export * from "./FaultReasonChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__